import { Toast } from "vant";
import envs from "../utils/envs.js"
import { getEnvName } from '../utils/env.js';
// 处理请求成功时的数据
export default function ({ data, config }) {
    if (data.statusCode == "0") {
        return typeof data.data == "string" ? JSON.parse(data.data) : data.data;
    } else if (data.statusCode == "-901") {
        const error = new Error(data.msg);
        error.statusCode = data.statusCode;
        if (!config.dialog) {
            Toast(error.message)
        }

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                getEnvName().then(envName => {
                    envs[envName]?.login.goToLogin()
                    reject(error)
                })
            }, 1000);
        })

    } else {
        const error = new Error(data.msg);
        error.statusCode = data.statusCode;
        if (!config.dialog) {
            Toast(error.message)
        }
        return Promise.reject(error);
    }
}
